import { render, staticRenderFns } from "./PlanDetails.vue?vue&type=template&id=b8e28cce&scoped=true"
import script from "./PlanDetails.vue?vue&type=script&lang=js"
export * from "./PlanDetails.vue?vue&type=script&lang=js"
import style0 from "./PlanDetails.vue?vue&type=style&index=0&id=b8e28cce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e28cce",
  null
  
)

export default component.exports